export default "__VITE_ASSET__CF1C41M2__"